export default {"src":"/_next/static/media/section_register_1.e5e23649.svg","height":50000,"width":5000};